import { emitProductEvent } from '../../telemetry/productEvents'

/**
 * The turn currently streaming. Module state because a turn outlives the send
 * thunk that started it: "stop generating", "new chat" and loading another
 * session all end a turn from outside that closure.
 */
let activeTurn: { conversation_id: string; turn_id: string } | null = null

export const startChatTurn = (conversationId: string) => {
  const turn = { conversation_id: conversationId, turn_id: crypto.randomUUID() }
  activeTurn = turn
  return turn
}

/**
 * Close the open turn exactly once, whichever path got there first.
 *
 * @param reason `error`, `cancelled` or `navigated` for a response that never
 * completed; omit when the response finished and rendered.
 */
export const endChatTurn = (reason?: 'error' | 'cancelled' | 'navigated') => {
  if (!activeTurn) return
  const turn = activeTurn
  activeTurn = null

  emitProductEvent({
    name: reason
      ? 'labra_ai_chat_response_interrupted'
      : 'labra_ai_chat_response_completed',
    ...turn,
    ...(reason ? { interruption_reason: reason } : {}),
  })
}
